import React from 'react';

const MarketPanelKeySectorTrends = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">Key Sector Trends</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="key-sector-trends">
            <thead>
              <tr>
                <th>Sector</th>
                <th>Trend</th>
                <th>Strength</th>
                <th>Volume</th>
                <th>Top Stocks</th>
                <th>Market Cap (₹ Cr)</th>
                <th>P/E Ratio</th>
                <th>Dividend Yield</th>
                <th>52W High</th>
                <th>52W Low</th>
                <th>Current Value</th>
                <th>% Change</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.sector || '-'}</td>
                    <td>{item.trend || '-'}</td>
                    <td>{item.strength || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.top_stocks || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.pe_ratio || '-'}</td>
                    <td>{item.dividend_yield || '-'}</td>
                    <td>{item.week52_high || '-'}</td>
                    <td>{item.week52_low || '-'}</td>
                    <td>{item.current_value || '-'}</td>
                    <td>{item.percent_change || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanelKeySectorTrends; 